import React from 'react';
import { ADMIN_TABS, getAdminTab, type AdminTabType } from './adminTabConfig';
import '../connector/ConnectorShell.css';
import './AdminShell.css';

interface AdminTabBarProps {
  activeTab: AdminTabType;
  onTabChange: (tab: AdminTabType) => void;
}

const AdminTabBar: React.FC<AdminTabBarProps> = ({ activeTab, onTabChange }) => {
  const active = getAdminTab(activeTab);

  return (
    <div className="connector-tabbar-wrap admin-tabbar-wrap">
      <nav className="connector-tabbar" id="admin-tabs" aria-label="Admin sections">
        <div className="connector-tabbar__active-hint" aria-live="polite">
          <span className="connector-tabbar__active-dot" />
          <span className="connector-tabbar__active-label">{active.label}</span>
          <span className="connector-tabbar__active-group">{active.eyebrow}</span>
        </div>

        <div className="connector-tabbar__grid admin-tabbar__grid">
          {ADMIN_TABS.map((tab) => {
            const isActive = tab.id === activeTab;
            return (
              <button
                key={tab.id}
                id={`admin-tab-${tab.id}`}
                type="button"
                className={`connector-tabbar__tab ${isActive ? 'connector-tabbar__tab--active' : ''}`}
                title={tab.description}
                aria-current={isActive ? 'page' : undefined}
                onClick={() => onTabChange(tab.id)}
              >
                <span className="connector-tabbar__tab-icon">
                  <i className={`fas ${tab.icon}`} aria-hidden="true" />
                </span>
                <span className="connector-tabbar__tab-label">{tab.label}</span>
              </button>
            );
          })}
        </div>
      </nav>
    </div>
  );
};

export default AdminTabBar;
